import { Col, Layout, Modal, Row, message } from "antd";
import React from "react";
import MiCompAPI from "../../../util/api";
import TableWrapper from "../../elements/TableWrapper";
import AddBORT from "./AddBORT";
const { Content } = Layout;
const { confirm } = Modal;
class BrokerOfRecord extends React.Component {

    constructor(props) {
        super(props);
        this.columnsdata = [
            {
                title: "Profile Name",
                dataIndex: "profileName",
                sorter: (a, b) => a.profileName.localeCompare(b.profileName),
                sortDirections: ["descend", "ascend"],
            },
            {
                title: "Rules",
                dataIndex: "rule",
                render: (text, record) => {
                    return record.rules.filter(x=>x.val===true).map((x,i)=>{
                        return x.key+ ( record.rules.filter(x=>x.val===true).length-1!==i?",":"")
                    })
                },
                sorter: (a, b) => a.rule.localeCompare(b.rule),
                sortDirections: ["descend", "ascend"],
            },
            {
                title: "Action",

                render: (text, record) => {
                    return (
                        <div style={{ display: "flex", width: 20 }}>
                            <>
                                <i
                                    onClick={() => {
                                        this.EditBOR(record.id);
                                    }}
                                    className="fa fa-pencil fa-b"
                                    aria-hidden="true"
                                ></i>
                                <i
                                    style={{ marginLeft: 10 }}
                                    onClick={() => this.DeleteBORbyid(record["id"])}
                                    className="fa fa-trash fa-red "
                                    aria-hidden="true"
                                ></i>
                            </>
                        </div>
                    );
                },
            },
        ];
        this.state = {
            allBORs: true,
            data: [],           
            addBOR: false,
            isLoading: this.props.isLoading,
            eBOR: null,
        };
        this.api = new MiCompAPI(this.props.userPermandMasters);
    }
    componentDidMount() {
        this.GetAllBORs();
    }


    EditBOR = (val) => {
        this.api.invoke("GetAllBORbyid/"+val, "get", (data, status) => {
            if (status) {
                if (data.statusCode === 200) {
                   
                    this.setState({
                        addBOR:true,
                        eBOR:data.data
                    })           
                } else {
                    message.destroy();
                    message.error(data.statusMessage, 3);
                }
            }
        });
        
    };


    GetAllBORs() {
        this.api.invoke("GetAllBORs", "get", (data, status) => {
            if (status) {
                if (data.statusCode === 200) {
                    const field = data.data;
                    this.data = field;
                    this.setState({ allBORs: false });
                } else {
                    message.destroy();
                    message.error(data.statusMessage, 3);
                }
            }
        });
    }

    DeleteBORbyid = (id) => {
        confirm({
            title: "Do you want to delete this BOR?",
            onOk: () => {
                this.api.invoke("DeleteBORbyid/" + id, "patch", (data, success) => {
                    if (success) {
                        if (data.statusCode === 200) {
                            message.destroy();
                            message.success(data.statusMessage, 3);
                            this.setState({ isLoading: false });
                            this.GetAllBORs();
                        } else {
                            message.destroy();
                            message.error(data.statusMessage, 3);
                        }
                    }
                });
            },
            okText: "Yes",
            cancelText: "No",
            onCancel() { },
        });
    };


    InsertAndUpdateBOR = (data, callback) => {
        this.api.invoke(
            "InsertAndUpdateBOR",
            "post",
            (data, success) => {
                if (success) {
                    if (data.statusCode === 200) {
                        this.GetAllBORs();
                        message.destroy();
                        message.success(data.statusMessage, 3);
                        this.UserDefaultHandler();
                        callback(true);
                    } else {
                        message.destroy();
                        message.error(data.statusMessage, 3);
                        callback(false);
                    }
                } else {
                }
            },
            data
        );
    };


    UserDefaultHandler = () => {
        this.setState({ addBOR: false, eBOR: null });
    };

    render() {
        this.tableButtons = [
            {
                buttonType: "primary",
                content: "Add BOR",
                clickHandler: () => {
                    this.setState({ addBOR: true });
                },
            },
        ];
        return (
            <Content>
                {this.state.addBOR ? (
                    <Modal visible={this.state.addBOR}>
                        <AddBORT
                            userPermandMasters={this.props.userPermandMasters}
                            closeDrawerHandler={this.UserDefaultHandler}
                            submitHandler={this.InsertAndUpdateBOR}
                            width="500"
                            eBOR={this.state.eBOR}
                        />
                    </Modal>
                ) : null}
                <div className="mi_main_div" >
                    <Row span={24} style={{ marginLeft: "10px", marginRight: "12px" }}>
                        <Col span={24}>

                            <TableWrapper
                                columns={this.columnsdata} rowKey="id"
                                data={this.state.allBORs ? null : this.data}
                                loading={this.state.allBORs}
                                buttons={this.tableButtons}
                                title="Broker of Record"
                                search={true}
                            />
                        </Col>
                    </Row>
                </div>
            </Content>
        )
    }
}

export default BrokerOfRecord;